import {
    Avatar as ShadcnAvatar,
    AvatarFallback as ShadcnAvatarFallback,
    AvatarImage as ShadcnAvatarImage,
} from "@/components/ui/avatar";
import { cn } from "@/domains/shared/services/cn";
import * as React from "react";

export const Avatar = React.forwardRef<
    React.ElementRef<typeof ShadcnAvatar>,
    React.ComponentPropsWithoutRef<typeof ShadcnAvatar>
>(({ className, ...props }, ref) => (
    <ShadcnAvatar ref={ref} className={cn("size-10 overflow-hidden", className)} {...props} />
));
Avatar.displayName = "Avatar";

export const AvatarImage = React.forwardRef<
    React.ElementRef<typeof ShadcnAvatarImage>,
    React.ComponentPropsWithoutRef<typeof ShadcnAvatarImage>
>(({ className, ...props }, ref) => (
    <ShadcnAvatarImage ref={ref} className={className} {...props} />
));
AvatarImage.displayName = "AvatarImage";

export const AvatarFallback = React.forwardRef<
    React.ElementRef<typeof ShadcnAvatarFallback>,
    React.ComponentPropsWithoutRef<typeof ShadcnAvatarFallback>
>(({ className, ...props }, ref) => (
    <ShadcnAvatarFallback
        ref={ref}
        className={cn("bg-amber-200 font-display font-bold text-amber-700", className)}
        {...props}
    />
));
AvatarFallback.displayName = "AvatarFallback";
